/** @jsx jsx */
import React, { useCallback } from 'react';
import { jsx, css } from '@emotion/core';
import { useTheme } from '../../theme';
let ExternalLinkIcon = (props) => {
    return (jsx("svg", { width: (props.height * 120) / 130, height: props.height, viewBox: "0 0 130 120", style: { display: 'block' } },
        jsx("g", null,
            jsx("path", { d: "M130,100 C130,111.045695 122.239602,120 112.666667,120 L17.3333333,120 C7.76039767,120 0,111.045695 0,100 L0,20 C0,8.954305 7.76039767,0 17.3333333,0 L44,0 L64,20 L17.3333333,20 L17.3333333,100 L112.666667,100 L112.666,68.666 L130,86 L130,100 Z" }),
            jsx("path", { d: "M130,0 L130,65 L104.102214,40.246 L62.3474567,82.0017857 L47.4982143,67.1525433 L88.9182143,25.732 L62,0 L130,0 Z" }))));
};
ExternalLinkIcon = React.memo(ExternalLinkIcon);
let LinkText = React.forwardRef((props, ref) => {
    const theme = useTheme();
    return (jsx("a", Object.assign({}, props, { ref: ref, css: {
            color: theme.colors.link.text,
            '&:visited': {
                color: theme.colors.link.textVisited,
            },
        } })));
});
LinkText.displayName = 'LinkText';
LinkText = React.memo(LinkText);
const linkPopupCss = css({
    visibility: 'hidden',
    position: 'absolute',
    left: '100%',
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: '#fff',
    display: 'inline-flex',
    alignItems: 'center',
    border: '1px solid #ddd',
    borderRadius: '5px',
    padding: '5px',
    '& svg': {
        fill: '#333',
    },
});
let LinkPopup = (props) => {
    return (jsx("div", { contentEditable: false, css: linkPopupCss },
        jsx("a", { href: props.href, target: "_blank", rel: "noopener noreferrer" },
            jsx(ExternalLinkIcon, { height: 15 }))));
};
LinkPopup = React.memo(LinkPopup);
const Link = React.forwardRef((props, ref) => {
    const { href, openPopup, children, ...restProps } = props;
    const onLinkClick = useCallback((e) => {
        if (href == null) {
            return;
        }
        if (!e.metaKey && !e.shiftKey) {
            return;
        }
        const anchor = document.createElement('a');
        anchor.href = href;
        anchor.target = '_blank';
        anchor.rel = 'noopener noreferrer';
        anchor.click();
    }, [href]);
    return (jsx("span", { css: {
            position: 'relative',
            [openPopup ? '& *' : '&:hover *']: {
                visibility: 'visible',
            },
        } },
        jsx(LinkPopup, { href: href }),
        jsx(LinkText, Object.assign({}, restProps, { href: href, ref: ref, onClick: onLinkClick }), children)));
});
Link.displayName = 'Link';
export default React.memo(Link);
//# sourceMappingURL=Link.js.map